import './vendor';
import lazyLoading from './modules/lazyLoading';
import Vivus from '../../node_modules/vivus/dist/vivus.js';
require('/src/js/vendor/magnific/jquery.magnific-popup.min.js')

require('../js/vendor/mmenu/dist/jquery.mmenu')


lazyLoading.init();

$("#menu").mmenu({
	navbar: {
	  title: "Меню"
	}
 });

// var API = $("#menu").data( "mmenu" );

// $(".btn-close-mobile-menu").click(function() {
//    API.close();
// });


let $status = $('.pagingInfo');
let $slickElement = $('.slider');

$slickElement.slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	speed: 500,
	fade: true,
	cssEase: 'linear',
	autoplay: true,
  	autoplaySpeed: 2000,
	prevArrow: $("#main-slider-prev"),
	nextArrow: $("#main-slider-next"),
});


function teamCarousel() {


	$('.team-slider').each(function (index, slider) {
		$(slider).slick({
			dots: false,
			speed: 1000,
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			variableWidth: true,
			prevArrow: $(`.team-slider-prev--${index}`),
			nextArrow: $(`.team-slider-next--${index}`),
		});
	});

}

function teamCarouselDestrtoy() {
	if ($('.team-slider').hasClass('slick-initialized')) {
		$('.team-slider').slick('destroy');
	}      
}

teamCarousel() 

function teamTabs() {
	$(".team-main__slider .tab_item").not(":first").hide();
	$(".team-main__btns").not(":first").hide();
	$(".team-main__tabs .tab").click(function() {
		teamCarouselDestrtoy()
		teamCarousel()
		$(".team-main__tabs .tab").removeClass("active").eq($(this).index()).addClass("active");
		$(".team-main__slider .tab_item").hide().eq($(this).index()).fadeIn()
		$(".team-main__btns").hide().eq($(this).index()).fadeIn()

	}).eq(0).addClass("active");
}

teamTabs()



$('.partners-slider').slick({
	dots: false,
	speed: 1000,
	infinite: true,
	slidesToShow: 10,
	slidesToScroll: 10,
	prevArrow: $("#btn-partners-prev"),
	nextArrow: $("#btn-partners-next "),
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				rows: 4,
				variableWidth: false,
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		}
	]
});


function serviceMenuTabs() {
	$(".service-menu__subitem ").not(":first").hide();
	$(".service-menu__item ").click(function() {
		$(".service-menu__item").removeClass("is-active").eq($(this).index()).addClass("is-active");
		$(".service-menu__subitem").hide().eq($(this).index()).fadeIn()
	}).eq(0).addClass("is-active");
}

serviceMenuTabs()


function openServMenu() {
	let btnOpenMenu = document.querySelector('#serv-menu');
	let servMenu = document.querySelector('#service-menu');

	btnOpenMenu.addEventListener('click', () => {
		servMenu.classList.add("is-active");
		document.querySelector('.service-menu__overlay').classList.add("is-active");
	})
}


function closeServMenu() {
	let btnCloseMenu = document.querySelector('#btn-close-menu');
	let servMenu = document.querySelector('#service-menu');
	
	btnCloseMenu.addEventListener('click', () => {
		servMenu.classList.remove("is-active");
		document.querySelector('.service-menu__overlay').classList.remove("is-active");
	})

	document.querySelector('.service-menu__overlay').addEventListener('click', () => {
		servMenu.classList.remove("is-active");
		document.querySelector('.service-menu__overlay').classList.remove("is-active");
	})
}


openServMenu()
closeServMenu()


function searchModal()  {
	let btnOpenSearch  = document.querySelector('.header__btn-search');
	let searchForm = document.querySelector('.search--modal');
	let searchFormOverlay = document.querySelector('.search__overlay');
	let searchFormInput = document.querySelector('#search__input');
	let btnCloseSearch = document.querySelector('.search__close ');

	
	btnOpenSearch.addEventListener('click', ()=> {
		searchForm.classList.add("is-active");
		searchFormInput.focus();
		searchFormOverlay.classList.add("is-active");
	})

	btnCloseSearch.addEventListener('click', ()=> {
		searchForm.classList.remove("is-active");
		searchFormOverlay.classList.remove("is-active");
	})

	searchFormOverlay.addEventListener('click', ()=> {
		searchForm.classList.remove("is-active");
		searchFormOverlay.classList.remove("is-active");
	})
}

searchModal()

$(".accordeon dd").hide().prev().click(function() {
	$(this).parents(".accordeon").find("dd").not(this).slideUp().prev().removeClass("active");
	$(this).next().not(":visible").slideDown().prev().addClass("active");
});



function tabsService() {
	let tabsBlock = document.querySelectorAll('.accordeon__tabs');
	tabsBlock.forEach(element => {
		let tabItem = element.querySelectorAll('.tab_item');
		let tab = element.querySelectorAll('.tab');
		tabItem[0].classList.add('active');
		tab[0].classList.add('active');
		for (let i  = 0; i < tab.length; i++) {
			tab[i].addEventListener('click', ()=> {
				for (let i  = 0; i < tab.length; i++) {
					tab[i].classList.remove('active');
					tabItem[i].classList.remove('active');
				}
				tab[i].classList.add('active');
				tabItem[i].classList.add('active');
			})
		}
	})
}

tabsService()
if(document.querySelector('#gallery')) {
	function galleryOpen() {
		document.querySelector('.tab--1').addEventListener('click', ()=> {
			document.querySelector('#gallery').classList.remove('is-active');
		})
		if(document.querySelector('.tab--2')) {
			document.querySelector('.tab--2').addEventListener('click', ()=> {
				document.querySelector('#gallery').classList.remove('is-active');
			})
		}
		document.querySelector('.tab--3').addEventListener('click', ()=> {
			document.querySelector('#gallery').classList.add('is-active');
		})
	}
	galleryOpen()
}



$(".specialist__tabs .tab_item").not(":first").hide();
$(".specialist__tabs .tab").click(function() {
	$(".specialist__tabs .tab").removeClass("active").eq($(this).index()).addClass("active");
	$(".specialist__tabs .tab_item").hide().eq($(this).index()).fadeIn()
}).eq(0).addClass("active");


/*Magnific модальное окно */
$('.popup-with-form').magnificPopup({
	type: 'inline',
	preloader: false,
	focus: '#search__input',
	mainClass: 'mfp-fade',
	callbacks: {
		beforeOpen: function() {
			if($(window).width() < 700) {
				this.st.focus = false;
			} else {
				this.st.focus = '#name';
			}
		}
	}
});

/*Magnific Фото в модалке*/
$('.popup').magnificPopup({
	type: 'image',
	closeOnContentClick: true,
	closeBtnInside: false,
	fixedContentPos: true,
	mainClass: 'mfp-fade mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
	image: {
		verticalFit: true
	},
	zoom: {
		enabled: true,
		duration: 300 // don't foget to change the duration also in CSS
	}
});


$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
	disableOn: 700,
	type: 'iframe',
	mainClass: 'mfp-fade',
	removalDelay: 160,
	preloader: false,

	fixedContentPos: false
});



//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$("#order").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$.magnificPopup.close();
		$("#order-done").fadeIn();
		setTimeout(function() {
			// Done Functions
			$("#order-done").fadeOut();
			
			th.trigger("reset");
		}, 3000);
	});
	return false;
});

//E-mail Ajax Send
//Documentation & Example: https://github.com/agragregra/uniMail
$("#ask").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$.magnificPopup.close();
		$("#order-done").fadeIn();
		setTimeout(function() {
			// Done Functions
			$("#order-done").fadeOut();
			
			th.trigger("reset");
		}, 3000);
	});
	return false;
});



$("#review").submit(function() { //Change
	var th = $(this);
	$.ajax({
		type: "POST",
		url: "assets/mail.php", //Change
		data: th.serialize()
	}).done(function() {
		$.magnificPopup.close();
		$("#review-done").fadeIn();
		setTimeout(function() {
			// Done Functions
			$("#review-done").fadeOut();
			
			th.trigger("reset");
		}, 3000);
	});
	return false;
});







$('.product-slider').slick({
	dots: true,
	speed: 1000,
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	appendDots: $('.slick-dots-custom'),
	prevArrow: '<button type="button" class="btn-slider prev"><img src="/assets/build/images/sprites/svg/prev.svg"></button>',
	nextArrow: '<button type="button" class="btn-slider next"><img src="/assets/build/images/sprites/svg/next.svg"></button>',
	asNavFor: '.product-slider-thumb',
});

$('.product-slider-thumb').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	vertical: true,
	asNavFor: '.product-slider',
	focusOnSelect: true,
	arrows: false,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
				vertical: false,
		    }
		}
	]
});


$(".scroll").on("click","a", function (event) {
    // исключаем стандартную реакцию браузера
    event.preventDefault();

    // получем идентификатор блока из атрибута href
    var id  = $(this).attr('data-scroll-to'),

    // находим высоту, на которой расположен блок
        top = $(id).offset().top;

    // анимируем переход к блоку, время: 800 мс
    $('body,html').animate({scrollTop: top}, 800);
});


/*Magnific галерея*/
$('.popup-gallery').magnificPopup({
	delegate: 'a',
	type: 'image',
	tLoading: 'Загрузка изображения #%curr%...',
	mainClass: 'mfp-fade mfp-img-mobile',
	gallery: {
		enabled: true,
		navigateByImgClick: true,
		preload: [0,1] // Will preload 0 - before current, and 1 after the current image
	},
	image: {
		tError: '<a href="%url%">Изображение #%curr%</a> не загружено.',
		titleSrc: function(item) {
			return '';
		}
	}
});


let btnModal = document.querySelectorAll('.btn--modal');
btnModal.forEach(element => element.addEventListener('click', replaceTitleModal));

function replaceTitleModal() {
	let modalForm = document.querySelector('#order');
	let themeTab = modalForm.querySelector('.form__tab');
	themeTab.value = this.dataset.title;
}